import { useCallback, useState } from 'react';
import { toast } from 'sonner';

import { useAxios } from '@/hooks/useAxios';
import { getQueryKey } from '@/hooks/useQueryKeys';
import { queryClient } from '@/queryclient';
import { ResourceType } from '@/types';

interface PatchAndPRResponse {
  conversation_id: string;
  job_key: string;
  status: string;
}

export function usePatchAndPR() {
  const axios = useAxios();
  const [isLoading, setIsLoading] = useState(false);

  const triggerPatchAndPR = useCallback(
    async (riskKey: string): Promise<PatchAndPRResponse | null> => {
      if (isLoading) return null;
      setIsLoading(true);
      const toastId = `patch-and-pr-${Date.now()}`;
      toast.loading('Starting Patch & PR...', { id: toastId });
      try {
        const response = await axios.post<PatchAndPRResponse>(
          '/constantine/patch-and-pr',
          { risk_key: riskKey }
        );
        const data = response.data;
        queryClient.invalidateQueries({
          queryKey: getQueryKey.getMy(ResourceType.Risk),
        });
        toast.success('Patch & PR started', {
          id: toastId,
          duration: 4000,
        });
        return data;
      } catch (error) {
        console.error('[usePatchAndPR] Failed:', error);
        toast.error('Failed to start Patch & PR', { id: toastId });
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [axios]
  );

  return { triggerPatchAndPR, isLoading };
}
